import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { CustomerDisplayScreen } from '../../../customer-display/enum/customer-display.enum';

const initialState: CustomerDisplayState = {
  currentScreen: CustomerDisplayScreen.LockedScreen,
};

class CustomerDisplayReducer extends ImmerReducer<CustomerDisplayState> {
  public setScreen(newScreen: CustomerDisplayScreen): void {
    this.draftState.currentScreen = newScreen;
  }
}

export const CustomerDisplayActions = createActionCreators(CustomerDisplayReducer);
export const CustomerDisplayReducerFunction = createReducerFunction(
  CustomerDisplayReducer,
  initialState,
);

export interface CustomerDisplayState {
  currentScreen: CustomerDisplayScreen;
}
